// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"4e8a15c2","155":"9401d97b","217":"a74801d0","528":"58efaba6","536":"4e8a15c2","928":"4e8a15c2"}[chunkId] + ".chunk.css";
};